import { observer } from 'mobx-react-lite'
import { Button, Status } from 'shared/ui'
import { useMessageFieldContext } from 'widgets/MessageField/context/MessageFieldContext'
import { RequestReviewContent } from 'widgets/RequestReview/ui/RequestReviewContent/RequestReviewContent'

export const RequestReviewDropdownItem = observer(() => {
  const messageFieldStore = useMessageFieldContext()

  const onOpen = () => {
    messageFieldStore.setMoreDropdownComponent((onClose) => (
      <RequestReviewContent onCloseMenu={onClose} />
    ))
  }

  return (
    <Button
      typeBtn={'menuItem'}
      text={'Request review'}
      icon={'starFilled1'}
      textRight={<Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />}
      onClick={onOpen}
    />
  )
})
